<template>
    <el-dialog
        class="set-private"
        :visible.sync="setPrivateVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Set private product"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="setPrivateForm"
                :model="setPrivateForm"
                :rules="rules"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="User email" prop="email" size="small">
                            <!-- <el-select
                                v-model="setPrivateForm.user_id"
                                placeholder="Please input user"
                                filterable
                                clearable
                                :filter-method="userSelect"
                                :remote="true"
                            >
                                <el-option
                                    v-for="item in userList"
                                    :key="item.id"
                                    :label="item.username"
                                    :value="item.id"
                                ></el-option>
                            </el-select> -->
                            <el-input
                                v-model="setPrivateForm.email"
                            ></el-input>

                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="SKU" prop="sku" size="small">
                            <el-input
                                type="textarea"
                                v-model="setPrivateForm.sku"
                                :autosize="{ minRows: 8, maxRows: 10 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="setPrivateVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            setPrivateForm: {
                email: "",
                sku: "",
            },
            rules: {},
            userList: [],
        };
    },
    methods: {
        closeDialog() {
            this.userList = [];
            this.$refs["setPrivateForm"].clearValidate();
            this.$refs["setPrivateForm"].resetFields();
            this.$emit("update:setPrivateVisible", false);
        },
        save() {
            console.log(this.setPrivateForm.sku);
            console.log(this.setPrivateForm.sku.split("\n"));
            cmofferApi
                .privateProducts(
                    {
                        email: this.setPrivateForm.email,
                        sku: this.setPrivateForm.sku.split("\n"),
                    },
                    "post"
                )
                .then((res) => {
                    if (res) {
                        this.$message.success(
                            this.$i18n.locale == "zh" ? "编辑成功" : "Success"
                        );
                        this.closeDialog();
                    }
                });
        },
        userSelect(val) {
            cmofferApi.userSelect({ keyword: val }, "get").then((res) => {
                if (res) {
                    console.log(res);
                    this.userList = res.data;
                }
            });
        },
    },
    props: {
        setPrivateVisible: Boolean,
    },
    watch: {
        setPrivateVisible(val) {},
    },
};
</script>
<style lang="scss" scoped>
.set-private {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
